import { render, staticRenderFns } from "./header-sort-button.vue?vue&type=template&id=01e532bd&scoped=true&"
import script from "./header-sort-button.vue?vue&type=script&lang=js&"
export * from "./header-sort-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e532bd",
  null
  
)

export default component.exports